import { render } from "./ContactUs.vue?vue&type=template&id=7482cf14"
import script from "./ContactUs.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactUs.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/ContactUs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7482cf14"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7482cf14', __exports__)) {
    api.reload('7482cf14', __exports__)
  }
  
  module.hot.accept("./ContactUs.vue?vue&type=template&id=7482cf14", () => {
    api.rerender('7482cf14', render)
  })

}


export default __exports__